<template>
<!--=== Content Part ===-->
<div > 
    <terms-en v-if="this.$cookies.get('lang_chap') && this.$cookies.get('lang_chap').indexOf('en') !== -1">
    </terms-en>
     <terms-fr v-else>
    </terms-fr>
</div>
</template>

<script>

import TermsFr from './TermsFr.vue'
import TermsEn from './TermsEn.vue'
export default {
  name: 'Terms',
  data () {
    return {
      userLang: navigator.language || navigator.userLanguage
    }
  },
  components: {
    TermsFr,
    TermsEn
  }
}
</script>
<style>
.legal p {
    font-size: 1.4em;
    line-height: 1.4;
}
</style>



// WEBPACK FOOTER //
// Terms.vue?afe06618